import request from '../utils/request'
import Config,{MethodType} from '../config/';
import {routerRedux} from 'dva/router';
let echart = {
    namespace:'echart',
    state:{
        monthTj :[],
    },
    effects:{
        *getMonthTj({payload},{call,put}){
         let res =  yield call(request('xlc/echarts/MonthTj',{
                method:MethodType.GET,
                params:{appid:Config.appid,
                    data:{...payload}
                }
            }));
 
            yield put({type:'update',payload:{monthTj:res.data}});
        },
        *toZdrCusMomthTj({payload},{call,put}){
            yield put({type:"update",payload:{
                AAE002:payload.AAE002,
                AAE004:payload.AAE004
            }});
            yield put(routerRedux.push(payload.route));
        },
        *getZdrCusMonthTj({payload},{call,put}){

            let res =  yield call(request('/ghs/echarts/MonthTj/getZdrCusMonthTj',{
                   method:MethodType.GET,
                   params:{appid:Config.appid,
                       data:{...payload}
                   }
               }));
               console.log(res);
               return res.data;
           }
    },
    reducers:{
        update(state, { payload }) {
            return {
                ...payload
            }
        }   
    }

};

export default echart;